export const openCinetPayExternally = async (value) => {
  const platform = process.env.REACT_APP_PLATFORM || "web";
  const androidDistribution = (process.env.REACT_APP_ANDROID_DISTRIBUTION || "play").toLowerCase();
  if (platform === "android" && androidDistribution !== "direct") {
    throw new Error("PAIEMENT_ANDROID_INTERDIT");
  }
  const url = new URL(value);
  const officialCheckoutPath = url.pathname === "/checkout" || url.pathname.startsWith("/checkout/");
  if (url.protocol !== "https:" || !["secure.cinetpay.net", "secure.cinetpay.co"].includes(url.hostname) || !officialCheckoutPath) {
    throw new Error("URL_CINETPAY_REFUSEE");
  }
  if (platform === "windows") {
    const invoke = window.__TAURI_INTERNALS__?.invoke;
    if (typeof invoke !== "function") throw new Error("OUVERTURE_EXTERNE_INDISPONIBLE");
    await invoke("plugin:opener|open_url", { url: url.toString(), openWith: null });
    return;
  }
  if (platform === "android") {
    const browser = window.Capacitor?.Plugins?.Browser;
    if (typeof browser?.open !== "function") throw new Error("OUVERTURE_EXTERNE_INDISPONIBLE");
    await browser.open({ url: url.toString() });
    return;
  }
  window.open(url.toString(), "_blank", "noopener,noreferrer");
};
